<template>
  <div class="container">
    <typeList />
    <div v-loading="isLoading" class="my-table">
      <div class="table-item" v-for="(item, index) in list" :key="index" @click="toDetail(item)">
        <div class="table-item-top">
          <div class="img">
            <img src="@/assets/img/home/59.png" alt="" />
          </div>
          <div class="right">
            <div class="name ellipsis2">{{ item.ExerciseName }}</div>
            <div class="value">
              <span>题量：{{ item.TotalNum }}</span>
            </div>
          </div>
        </div>

        <div class="content">
          {{ item.CourseName }}
        </div>
        <div class="flex mt20">
          <div class="type"># {{ item.ClassifyName }}</div>
          <div v-if="item.Price > 0" class="red">
            ¥ <span class="amout">{{ item.Price }}</span>
          </div>
          <div v-else class="red"><span class="amout">免费</span></div>
        </div>
        <div class="flex">
          <div class="rate mt10">
            <span class="mr5">{{ item.StarNum }}</span>
            <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
            </el-rate>
          </div>
          <div class="user">
            <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
          </div>
        </div>
      </div>
    </div>
    <el-empty description="暂无内容" :image="empty1" v-if="list.length == 0 && !isLoading" />
    <el-pagination class="center my-pagination mt30 mb70" @current-change="(page) => getList(page)" background
      hide-on-single-page :page-size="15" layout="prev, pager, next" :total="count">
    </el-pagination>
  </div>
</template>

<script>
import { Exercise_GetList } from "@/api/qbank";
import typeList from "./child/typeList.vue";
export default {
  name: "qbank",
  components: {
    typeList,
  },
  data() {
    return {
      isLoading: false,
      title: "",
      PageIndex: 1,
      list: [],
      count: 0,
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(v) {
        this.getList();
      },
    },
  },

  created() {
    this.getList();
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/qbankDetail",
        query: { ExerciseID: item.ExerciseID },
      });
    },
    async getList(page = 1) {
      if (this.isLoading) {
        return;
      }
      this.PageIndex = page;
      this.isLoading = true;
      this.list = [];
      await Exercise_GetList({
        PageIndex: this.PageIndex,
        PageSize: 15,
        ...this.$route.query,
      })
        .then((res) => {
          this.list = res.data;
          this.count = res.count;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-table {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 194px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      margin-top: 15px;
      font-size: 20PX;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .table-item-top {
      display: flex;
      // align-items: center;
      gap: 20px;

      .img {
        width: 42px;
        height: 43px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .right {
        flex: 1;

        .name {
          font-size: 20PX;
          height: 52PX;
          color: #333333;
        }

        .value {
          margin-top: 10px;
          display: flex;
          gap: 30px;
          font-size: 16PX;
          color: #999999;
        }
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .type {
        font-size: 16PX;
        color: #999999;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        flex: 1;
        margin-right: 5px;
      }

      .amout {
        font-size: 24PX;
        font-weight: bold;
      }

      .red {
        font-size: 16PX;
        color: #e12a14;
        font-weight: bold;

      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;

        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }

      .rate {
        display: flex;
        font-weight: bold;
        font-size: 20PX;
        color: #e12a14;
      }
    }
  }
}
</style>
